<div class="wrap">
  <fa-icon [icon]="faGlobe"></fa-icon>
  <h4>Une erreur est survenue</h4>
  <p>Vous allez être redirigé vers la page pricipale</p>
</div>
